module.exports = __webpack_public_path__ + "site/img/138.348c677a.jpg";